import Projeto from './componentes/Projeto.vue';

export default {
  path: '/projeto',
  component: Projeto,
  meta: { auth: true },
  name: 'projeto',
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/projeto/rotas.js